export default __webpack_public_path__ + "static/study-3-65f989d12136d787bb903a797b790d5e.jpg";